import PageHeader from "@/components/PageHeader";
import { CONTACT_EMAIL } from "@/lib/brand";

const Confidencialidad = () => (
  <div data-testid="confidencialidad-page">
    <PageHeader
      eyebrow="Legal"
      title="Política de Confidencialidad."
      subtitle="El secreto profesional es la base de la relación terapéutica. Esta política describe cómo lo protegemos y las únicas circunstancias, reconocidas por ley, en que puede levantarse."
    />

    <section className="px-6 md:px-14 pb-24 max-w-4xl">
      <article
        className="card-soft p-8 md:p-12 space-y-6"
        style={{ background: "#fbf6ec" }}
      >
        <Block title="1. Compromiso de confidencialidad">
          <p>
            Toda la información que usted comparte con nosotros, verbal, escrita
            o registrada durante las sesiones, está protegida por el secreto
            profesional, el código ético del psicólogo y la legislación vigente
            en México (LFPDPPP y códigos deontológicos aplicables).
          </p>
        </Block>

        <Block title="2. ¿Quién tiene acceso a su información?">
          <ul style={list}>
            <li>Únicamente el psicólogo responsable de su caso.</li>
            <li>En terapia de pareja o familia, cada persona conserva su propio
                espacio de confidencialidad; no compartimos con la pareja/familia
                lo tratado individualmente sin su consentimiento expreso.</li>
            <li>Nunca compartimos información con empleadores, familiares no
                involucrados en el proceso, ni con terceros.</li>
          </ul>
        </Block>

        <Block title="3. Sesiones en línea">
          <ul style={list}>
            <li>Las sesiones se realizan mediante plataformas cifradas de
                videollamada (Google Meet, Zoom o equivalente).</li>
            <li>No grabamos las sesiones salvo con su consentimiento por escrito
                y con una finalidad clínica o forense específica.</li>
            <li>Le sugerimos participar desde un espacio privado y con audífonos
                para reforzar su propia confidencialidad.</li>
          </ul>
        </Block>

        <Block title="4. Registro y expediente clínico">
          <p>
            Se elabora un expediente conforme a la NOM-004-SSA3 (o su equivalente
            aplicable). Se almacena de forma cifrada y con acceso restringido. La
            conservación mínima es de 5 años a partir del último contacto, según
            la normatividad vigente.
          </p>
        </Block>

        <Block title="5. Excepciones legales al secreto profesional">
          <p>
            La confidencialidad puede levantarse <strong>únicamente</strong> en las
            siguientes circunstancias, previstas por la ley:
          </p>
          <ul style={list}>
            <li>Riesgo grave e inminente para la vida del propio paciente o de
                terceros identificables.</li>
            <li>Sospecha razonable de maltrato o abuso a un menor de edad,
                persona mayor o persona en situación de vulnerabilidad.</li>
            <li>Requerimiento judicial expreso emitido por autoridad competente.</li>
            <li>Cuando el propio paciente autorice por escrito la divulgación.</li>
          </ul>
        </Block>

        <Block title="6. Peritaje forense">
          <p>
            En el ámbito forense, los datos recabados durante la evaluación se
            utilizan exclusivamente para la elaboración del dictamen o
            metaperitaje solicitado, y se entregan únicamente a la autoridad o
            parte que legítimamente los requirió.
          </p>
        </Block>

        <Block title="7. Contacto">
          <p>
            Cualquier duda relacionada con esta política puede escribirla a{" "}
            <a href={`mailto:${CONTACT_EMAIL}`} style={ink}>{CONTACT_EMAIL}</a>. Nos
            comprometemos a responder en un plazo máximo de 10 días hábiles.
          </p>
        </Block>
      </article>
    </section>
  </div>
);

const Block = ({ title, children }) => (
  <section>
    <h2
      style={{
        fontFamily: "Cormorant Garamond, serif",
        fontSize: "1.35rem",
        fontWeight: 600,
        color: "var(--p-black)",
      }}
    >
      {title}
    </h2>
    <div
      className="mt-3 space-y-2"
      style={{
        fontFamily: "Cormorant Garamond, serif",
        color: "var(--p-brown)",
        fontSize: "1.05rem",
        lineHeight: 1.7,
      }}
    >
      {children}
    </div>
  </section>
);

const list = { paddingLeft: 20, listStyle: "disc" };
const ink = { color: "var(--p-burgundy)", textDecoration: "underline" };

export default Confidencialidad;
